import { Chip, useTheme } from '@mui/material';
import { lightGreen } from '@mui/material/colors';
import React from 'react';

export const BackorderChip = React.forwardRef<HTMLDivElement>((props, ref) => {
  const theme = useTheme();

  return (
    <Chip
      ref={ref}
      {...props}
      label="Backorder"
      sx={{
        px: 1.25,
        py: '3px',
        borderRadius: 0.5,
        backgroundColor: lightGreen[50],
        height: 'auto',
        '& .MuiChip-label': {
          color: theme.sass.sendTypeSingle,
          p: 0,
          fontSize: 13,
          height: 18,
          display: 'flex',
          alignItems: 'center',
        },
      }}
    />
  );
});
